import React from "react";
import { FieldRendererProps } from "../types";
import { StyledFormControl, ErrorMessage } from "../styles";
import { TipoFormulario } from "../../../services/constantes";

export const TextFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, handleBlur, errors,
}) => (
  <>
    <StyledFormControl
      type={campo.tipo}
      readOnly={campo.nome === "id" || modo === TipoFormulario.tpVisualizacao}
      required={campo.required}
      value={getFieldValue(campo.nome)}
      onChange={(e: any) => handleInputChange(campo.nome, campo.tudoMaiusculo ? e.target.value.toUpperCase() : e.target.value)}
      onBlur={() => handleBlur(campo)}
      disabled={campo.apenasLeitura || false}
      maxLength={campo.maximoCaracteres || 100}
      minLength={campo.minimoCaracteres || 0}
      hasError={!!errors[campo.nome]}
      onKeyDown={(e: any) => {
        if (campo.tipo === "number") {
          if (e.key === '.' || e.key === ',') {
            e.preventDefault();
          }
        }
      }}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
